import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { UserResponseModel } from "src/app/model/UserResponseModel";
import { SopMasterModel } from "src/app/model/SopMasterModel";
import { SopConfigResponseWrapperModel } from "src/app/model/SopConfigResponseWrapperModel";
import { SopConfigResponse } from "src/app/model/SopConfigResponse";

@Component({
  selector: "app-secure-sop-master",
  templateUrl: "./sop-master.component.html",
  styleUrls: ["./sop-master.component.scss"],
})
export class SopMasterAuComponent implements OnInit {
  key: number;
  userKey: number;
  pageMode: string;
  sopConfigResponse: SopConfigResponse[] = [];
  sopConfigurationResponses: SopConfigResponseWrapperModel;
  userModel: UserResponseModel;
  sopModel: SopMasterModel;
  nonEditable: boolean = false;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  roles: { [key: number]: string };
  boards: { [key: number]: string };
  boardWiseDepartments: { [key: number]: { [key: number]: string } };
  departmentWiseDesignations: { [key: number]: { [key: number]: string } };

  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.key = +params["key"];

      this.masterService.initSopMasterForm(this.key).subscribe((data: any) => {
        if (data.status === "SUCCESS") {
          this.pageMode = "Edit";
          this.nonEditable = data.nonEditable;
          this.sopConfigurationResponses = data;
          this.sopConfigResponse = data.sopConfigurationResponses;
          // console.log(
          //   "this.sopConfigurationResponses",
          //   this.sopConfigurationResponses
          // );

          let sopMainMasterLst: FormArray = this.form.get(
            "userResponsibilityLst"
          ) as FormArray;

          for (let k = 0; k < this.sopConfigResponse.length; k++) {
            let sopMainMasterObj = this.sopConfigResponse[k];

            let frmGrp = new FormGroup({
              key: new FormControl(sopMainMasterObj.sopConfigurationKey),
              userSubResponsibilityLst: new FormArray([]),
              sopMain: new FormControl(
                sopMainMasterObj.steps,
                Validators.required
              ),
              displayOrder: new FormControl(
                sopMainMasterObj.displayOrder,
                Validators.required
              ),
            });

            let sopSubMasterResponses =
              sopMainMasterObj.sopConfigurationResponses;

            let sopSubMasterLst: FormArray = frmGrp.get(
              "userSubResponsibilityLst"
            ) as FormArray;

            for (let n = 0; n < sopSubMasterResponses.length; n++) {
              let sopSubMasterResponseObj = sopSubMasterResponses[n];

              sopSubMasterLst.push(
                new FormGroup({
                  key: new FormControl(
                    sopSubMasterResponseObj.sopConfigurationKey
                  ),
                  sopSubMain: new FormControl(
                    sopSubMasterResponseObj.steps,
                    Validators.required
                  ),
                  subDisplayOrder: new FormControl(
                    sopSubMasterResponseObj.displayOrder,
                    Validators.required
                  ),
                })
              );
            }
            sopMainMasterLst.push(frmGrp);
            // console.log("frmGrp", frmGrp.value);
          }

          this.form.patchValue({
            key: this.sopConfigurationResponses.key,
            sopName: this.sopConfigurationResponses.sopName,
          });
        } else {
          this.errorToast(data.errorMessage, 5 * 1000);
        }
      });
    });
    this.form = new FormGroup({
      // sopMain: new FormControl(null, [
      //   Validators.required,
      //   Validators.maxLength(300),
      // ]),
      // sopSubMain: new FormControl(null, [
      //   Validators.required,
      //   Validators.maxLength(255),
      // ]),
      sopName: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),

      userResponsibilityLst: new FormArray([]),
    });
  }

  onSubmit() {
    if (this.pageMode === "Edit") {
      this.update();
      console.log("Update");
    } else {
      this.save();
      console.log("Save");
    }
  }

  async save() {
    console.log(this.form.value.userResponsibilityLst);

    this.masterService
      .saveSopMaster({
        key: null,
        sopName: this.form.value.sopName,
        activeFlag: this.form.value.activeFlag,
        // sopMain: this.form.value.sopMain,
        // sopSubMain: this.form.value.sopSubMain,
        userResponsibilityLst: this.form.value.userResponsibilityLst.map(
          (ur) => ({
            key: ur.key,
            sopMain: ur.sopMain,
            displayOrder: ur.displayOrder,
            sopSubMain: ur.userSubResponsibilityLst.map((ur) => ({
              sopSubMain: ur.sopSubMain,
              subDisplayOrder: ur.subDisplayOrder,
            })),
          })
        ),
      })
      .subscribe(
        (data: any) => {
          if (data.status === "SUCCESS") {
            this.successToast();
            // window.location.reload();
            this.router.navigate(["/secure", "sop-master", "list"]);
            this.ngOnInit();
          } else {
            this.isSubmitDisabled = false;
            this.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.isSubmitDisabled = false;
          console.log(error);
          this.errorToast(error.error.errorMessage, 5 * 1000);
        }
      );
  }

  async update() {
    console.log("this.sopMainkey", this.key);

    this.masterService
      .updateSopMaster(this.key, {
        key: this.key,
        sopName: this.form.value.sopName,
        activeFlag: this.form.value.activeFlag,
        // sopSubMain: this.form.value.sopSubMain,
        userResponsibilityLst: this.form.value.userResponsibilityLst.map(
          (ur) => ({
            key: ur.key,
            sopName: ur.sopName,

            sopMain: ur.sopMain,
            displayOrder: ur.displayOrder,
            sopSubMain: ur.userSubResponsibilityLst.map((ur) => ({
              key: ur.key,
              sopSubMain: ur.sopSubMain,
              subDisplayOrder: ur.subDisplayOrder,
            })),
          })
        ),
      })
      .subscribe(
        (data: any) => {
          if (data.status === "SUCCESS") {
            this.successToast();
            this.router.navigate(["/secure", "sop-master", "list"]);
          } else {
            this.isSubmitDisabled = false;
            this.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.isSubmitDisabled = false;
          console.log(error);
          this.errorToast(error.error.errorMessage, 5 * 1000);
        }
      );
  }

  async successToast() {
    await this._snackBar.open("Sop Master saved successfully.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open("Please fill required fields", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  addResponsibility() {
    let selectedUserResponsibilityLst: FormArray = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;
    // console.log("userResponsibilityLst", selectedUserResponsibilityLst);

    selectedUserResponsibilityLst.push(
      new FormGroup({
        key: new FormControl(null),
        sopMain: new FormControl(null, Validators.required),
        displayOrder: new FormControl(
          selectedUserResponsibilityLst.length + 1,
          Validators.required
        ),
        userSubResponsibilityLst: new FormArray([]),
      })
    );
  }

  addSubResponsibility(i: number) {
    let selectedUserResponsibilityLst: FormArray = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;
    let selectedUserResponsibility = selectedUserResponsibilityLst.at(
      i
    ) as FormGroup;
    let selectedSubUserResponsibilityLst: FormArray =
      selectedUserResponsibility.get("userSubResponsibilityLst") as FormArray;

    selectedSubUserResponsibilityLst.push(
      new FormGroup({
        key: new FormControl(null),
        sopSubMain: new FormControl(null, Validators.required),
        subDisplayOrder: new FormControl(
          selectedSubUserResponsibilityLst.length + 1,
          Validators.required
        ),
      })
    );
  }

  deleteByActiveFlag(i: number, j: number, key: number) {
    this.deleteResponsibility(i, j, key);

    // if (confirm("Do you want to De-Activate the User")) {
    //   this.masterService.deleteSubMain(j, "N").subscribe((data: any) => {
    //     if (data.status === "SUCCESS") {
    //       // let selectedObj = this.page.content.find((o) => o.key === key);
    //       // selectedObj.activeFlag = "N";
    //     } else {
    //       this.errorToast(data.errorMessage);
    //     }
    //   });
    // }
  }

  deleteResponsibility(i: number, j: number, key: number) {
    let selectedUserResponsibilityLst: FormArray = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;
    let selectedUserResponsibility = selectedUserResponsibilityLst.at(
      i
    ) as FormGroup;
    let selectedSubUserResponsibilityLst: FormArray =
      selectedUserResponsibility.get("userSubResponsibilityLst") as FormArray;
    if (this.pageMode === "Edit" && key != null && key > 0) {
      console.log("sub steps key", key);
      this.masterService.deactiveSopSubSteps(key).subscribe((status) => {});
    }

    return selectedSubUserResponsibilityLst.removeAt(j);
  }

  deleteMaster(i: number, key: number) {
    let selectedUserResponsibilityLst: FormArray = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;
    if (this.pageMode === "Edit" && key != null && key > 0) {
      console.log("sop steps key => ", key);
      this.masterService.deactiveSopSteps(key).subscribe((status) => {});
    }
    selectedUserResponsibilityLst.removeAt(i);
  }

  get responsibilities() {
    return this.form.get("userResponsibilityLst")["controls"];
  }

  subResponsibilities(i: number) {
    let selectedUserResponsibilityLst: FormArray = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;
    let selectedUserResponsibility = selectedUserResponsibilityLst.at(
      i
    ) as FormGroup;
    let selectedSubUserResponsibilityLst: FormArray =
      selectedUserResponsibility.get("userSubResponsibilityLst") as FormArray;
    // console.log(i, selectedSubUserResponsibilityLst);
    return selectedSubUserResponsibilityLst
      ? selectedSubUserResponsibilityLst["controls"]
      : null;
  }
}
